module.exports = __webpack_public_path__ + "img/cadeado.d16731f8.png";